import { connect } from 'react-redux';
import { getFlags } from '../selectors';
import { FlagContext } from '../FlagContext';
export default connect(function (state) { return ({
    value: getFlags(state),
}); })(FlagContext.Provider);
//# sourceMappingURL=ConnectedFlagsProvider.js.map